import request from "../utils/request";

export function getStates() {
  return request({
    url: "/geo/states",
    method: "get",
  });
}

export function getCities(state) {
  return request({
    url: `/geo/states/${state}/cities`,
    method: "get",
  });
}
